/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import "./index.scss";
import moment from "moment";

import { duration } from 'utils'
// ui
import { Button } from "antd";
// animation
import { Fade } from "react-reveal";

// components
import Countdown from "../../../common/Countdown";

const PublicOffering = (props) => {
  const [countdown, setCountdown] = useState({
    days: null,
    hours: null,
    minutes: null,
    seconds: null,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const { timeTillDate, timeFormat } = props;
      const then = moment(timeTillDate, timeFormat);
      const now = moment().local();
      const countdown = moment(then - now);
      const days = then.diff(now, 'days')
      // const hours = countdown.format("HH");
      const hours = 23 - now.hours();
      const minutes = countdown.format("mm");
      const seconds = countdown.format("ss");
      setCountdown({ days, hours, minutes, seconds });
    }, 1000);
    return () => clearInterval(interval);
  }, [props]);

  return (
    <div className="publicOffering">
      <Fade bottom duration={duration}>
        <div className="content">
          <div className="contentLeft">
            <div className="detail">
              <h4>Testnet launch</h4>
              <p className="description">
                PCOG public offering on Lemonade followed by liquidity event on
                Quickswap Sept 30th
              </p>

              <div className="more">
                <Button
                  href="https://etherscan.io/token/0xdF07D0D7b794c3008b60b16cBCde1A81CC2ede36"
                  target="_blank"
                  rel="noreferrer"
                  type="link"
                >
                  Etherscan
                </Button>
                <Countdown
                  days={countdown.days}
                  hours={countdown.hours}
                  minutes={countdown.minutes}
                  seconds={countdown.seconds}
                />
              </div>
            </div>
          </div>

          <div className="contentRight">
            <div className="detail">
              <h1>Sept 30th</h1>
              <h6>Expire on</h6>
              <a href="#">Conditions of sale</a>
              {/* <Button className="btnWhitelist">Whitelist</Button> */}
            </div>
          </div>
        </div>
      </Fade>
    </div>
  );
};

export default PublicOffering;
